import type { Branded } from "@@/utilities/branded";
import { setWithinPercentageRange } from "@@/utilities/set-within-range";
import { z } from "zod";

const hexColorTypeName = "HexColor";
type HexColor = Branded<string, typeof hexColorTypeName>;

const hexRegEx = /^#[0-9a-fA-F]{3,8}$/i;
const hexColorZodSchema = z
    .string()
    .regex(
        hexRegEx,
        "invalid hex color value",
    ) as unknown as z.ZodSchema<HexColor>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isHexColor = (color: any): color is HexColor => {
    return typeof color === "string" && hexRegEx.test(color);
};
const hexColor: (value: string) => HexColor = (value: string): HexColor => {
    if (!isHexColor(value))
        throw new Error(
            "value is not valid hex color; value: " + JSON.stringify(value),
        );
    return value;
};

const addAlphaToHexColor = (color: HexColor, opacity: number): HexColor => {
    if (color.length > 7) throw new Error("color already has alpha value");
    const alpha = Math.round(setWithinPercentageRange(opacity) * 255);
    return (color +
        alpha.toString(16).toUpperCase().padStart(2, "0")) as HexColor;
};

export {
    addAlphaToHexColor,
    hexColor,
    hexColorTypeName,
    hexColorZodSchema,
    hexRegEx,
    isHexColor,
};
export type { HexColor };
